<template>
  <section class="section-three">
    <div class="section-three--wrapper">
      <div class="section-three--left">
        <div class="section-left-title">
          <span class="title">Ripartizione per anno</span>
        </div>
        <span class="text-three">
          Posizionamento di {{ infocar.nome }} per anno di immatricolazione
        </span>
        <div class="chart-one-container">
          <div class="qrt-bar-chart-one">
            <div style="width: 100%; height: 100%; position: relative;">
                <bar-chart-vertical :data="chartDataAnno" ></bar-chart-vertical>
            </div>
            <p class="text-three">La tua moto è stata immatricolata il: <span class="data">{{ infocar.immatricolazione }}</span></p>
          </div>

        </div>
      </div>
      <div class="section-three--right">
        <div class="section-left-title">
          <span class="title">Ripartizione per chilometraggio</span>
        </div>
        <span class="text-three">
          Posizionamento di {{ infocar.nome }} per chilometri percorsi
        </span>
        <div class="chart-two-container">
          <div class="qrt-bar-chart-two">
            <div style="width: 100%; position: relative;">
                <bar-chart-vertical :data="chartDataKm" ></bar-chart-vertical>
            </div>
            <p class="text-three">La tua moto ha: <span class="data">{{ formatNumber(focus.km_auto) }}km</span></p>
            <p class="text-three">La media km per il tuo veicolo è di: <span class="data">{{ formatNumber(focus.km_medio) }}km</span></p>
            <p class="text-three">Con un minimo di: <span class="data">{{ formatNumber(focus.km_min) }}km</span></p>
            <p class="text-three">E un massimo di: <span class="data">{{ formatNumber(focus.km_max) }}km</span></p>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BarChartVertical from './BarChartVertical';
export default {
  name: 'LivemarketDataDistribution',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
    focus: {
      type: Object,
      required: true,
    },
  },
  components: {
    BarChartVertical,
  },
  computed: {
    chartDataAnno() {
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    const backgroundColors = ['#ff6384', '#36a2eb', '#cc65fe', '#ffce56'];

    const datasets = quarters.map((quarter, index) => {
      const data = Object.keys(this.focus.conteggio_immatricolazione).map(anno => {
        const count = this.focus.conteggio_immatricolazione[anno][quarter] || 0;
        return count;
      });

      return {
        label: `Immatricolazioni ${quarter}`,
        backgroundColor: backgroundColors[index],
        data: data,
      };
    });

    return {
      labels: Object.keys(this.focus.conteggio_immatricolazione),
      datasets: datasets,
    };
  },
  chartDataKm() {
    const labels = Object.keys(this.focus.conteggio_chilometri || {});
    const formattedLabels = labels.map(label => this.formatKmRangeLabel(label));
    const data = labels.map(range => this.focus.conteggio_chilometri[range]);

    return {
      labels: formattedLabels,
      datasets: [{
        label: 'Distribuzione Veicoli/Chilometri',
        backgroundColor: '#d20a11',
        data: data,
      }],
    };
  }
},
methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      // Arrotonda decimali API (punto = virgola) a intero, poi migliaia IT
      const n = Math.round(Number(String(value).replace(',', '.')));
      if (Number.isNaN(n)) {
        return '';
      }
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    // Scaglioni grafico km: "0-15000" → "0-15.000" (formatNumber da solo svuota il label)
    formatKmRangeLabel(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const str = String(value).trim();
      if (/^\d+\s*-\s*\d+$/.test(str)) {
        return str
          .split('-')
          .map(part => this.formatNumber(part.trim()))
          .join('-');
      }
      return this.formatNumber(str);
    },
}
};
</script>

<style scoped>
.section-three {
  display: flex;
  padding: 40px 0px;
  border-bottom: 2px solid #e4e4e4;
  margin: 0px 100px;
}
.section-three--wrapper {
  max-width: 830px;
  width: 100%;
  margin: auto;
  display: flex;
}
.section-three--left {
  display: flex;
  flex-direction: column;
  width: 50%;
  border-right: 2px solid #e4e4e4;
  padding: 12px 75px 30px 0px;
}
.section-left-title {
  display: flex;
  justify-content: space-between;
}
.title {
  color: #d20a11;
  font-size: 21px;
  line-height: 28px;
  font-weight: bold;
}
.text-three {
  font-size: 0.875rem;
  line-height: 18px;
  margin-top: 6px;
}
.chart-one-container {
  position: relative;
}
.dot-black {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: black;
  position: absolute;
  bottom: 10px;
  left: 116px;
}
.dot-blue {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #d20a11;
  position: absolute;
  bottom: 10px;
  left: 168px;
}
.chart--banner {
  background-color: #d20a11;
  color: #ffffff;
  position: absolute;
  bottom: 26px;
  left: 140px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  line-height: 13px;
}
.chart--banner .one {
  font-weight: 300;
  font-size: 12px;
}
.chart--banner .two {
  font-weight: bold;
}
.chart-text-container {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.chart-text--one {
  left: 13px;
}
.chart-text {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0px;
}
.chart-text-title {
  font-size: 14px;
  line-height: 18px;
  color: #aaaaaa;
}
.chart-text-date {
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #aaaaaa;
}
.chart-text {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0px;
}
.text-center {
  text-align: center;
  color: white;
  padding: 12px 0;
}
.chart-text-title.middle {
  font-weight: 300;
  color: #333333;
}
.chart-text-date.middle {
  color: #333333;
}
.chart-text--three {
  right: 15px;
  text-align: right;
}

.chart-text {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0px;
}
.section-three--right {
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 12px 0px 30px 42px;
}
.chart-two-container {
  position: relative;
}
.data{
    color: #d20a11;
    font-weight: 600;
}
@media (max-width: 992px) {
  .section-three {
    padding: 40px 20px 80px;
    margin: 0px 40px;
  }
  .section-three--wrapper {
    flex-direction: column;
  }
  .section-three--left {
    width: 100%;
    border-right: none;
    padding: 0px;
    margin-bottom: 40px;
  }
  .section-three--right {
    padding: 0px;
    width: 100%;
    margin-top: 40px;
  }
}
@media (max-width: 600px) {
  .section-three {
    padding: 35px 0px 60px;
    margin: 0px 17px;
  }
  .section-three--right {
    border-top: 1px solid #e4e4e4;
    margin-top: 20px;
    padding-top: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataDistribution.vue